
import { defineComponent } from 'vue';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';;

export default defineComponent({
	name: 'bot-avatar',

	components: {
		QAvatar
	},

	props: {
		avatar: {
			type: String,
			required: true
		}
	},

	computed: {
		avatarSize(): string {
			return this.$q.screen.name === 'xs' ? '2rem' : '2.75rem';
		}
	}
});
